module.exports = __webpack_public_path__ + "new-logo-login.png?4435104ae4c9c19ce7ab3135e5220e99";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/new-logo-login.png
// module id = 394
// module chunks = 0